import { CommonStyles } from '../../styles/common.styles'

export const LinkStyles = {
  link: (className: string = '') => `${className} ${CommonStyles.anchorLink}`,
}
